var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20.8555 12L19.4455 10.59L13.8555 16.17V4H11.8555V16.17L6.26547 10.59L4.85547 12L12.8555 20L20.8555 12Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
